import _Api from '@/api/_Api';

import { BookingInterface, GetFilesInterface } from '@/interfaces/Bookings';

import { OrderInterface, OrderActivityInterface, UpdateOrderActivitiesInterface, InvoiceInterface, CreateReportInterface } from '@/interfaces/Order';

export class TasksApi extends _Api {
   static async find(params: any): Promise<{ Tasks: any[] }> {
      const response = await this.http().get('tasks', { params });
      return response.data;
   }
}
